import GeneralDialog from '../../../../../shared/general-dialog';
import { getDateTimeString, getTargetTypeLabel } from '../../shared/utils';
import { LabelSync } from '../../shared/types';

import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function GpanelContactsSyncDetailsDialog({
  sync,
  handleClose,
}: {
  sync: LabelSync;
  handleClose: () => void;
}) {
  return (
    <GeneralDialog
      open={true}
      handleClose={() => {
        handleClose();
      }}
      title={`Contact Sync Details`}
      maxWidth="md"
      dialogContent={
        <Stack gap={2}>
          <Card
            sx={(theme) => ({
              p: 2,
              backgroundColor: theme.palette.primary.light,
              mb: 0,
              mx: 2,
            })}
          >
            <Typography>
              <strong>{sync.name}</strong>
            </Typography>
            <Typography>{sync.description}</Typography>
            <Stack
              flexDirection="row"
              justifyContent="start"
              alignItems="center"
              flexWrap={'wrap'}
              gap={2}
              sx={{ mt: 1 }}
            >
              {[
                { label: 'Created By:', value: sync.createdBy },
                {
                  label: 'Created Date:',
                  value: getDateTimeString(sync.createdTime ?? 0),
                },
                {
                  label: 'Last Updated:',
                  value: getDateTimeString(sync.updatedTime ?? 0),
                },
              ].map((item) => (
                <Stack key={item.label} flexDirection="row" gap={1}>
                  <Typography>{item.label}</Typography>
                  <Typography>{item.value}</Typography>
                </Stack>
              ))}
            </Stack>
          </Card>
          <Stack alignItems="stretch" gap={2} sx={{ mt: 3, px: 2 }}>
            {[
              {
                label: 'gPanel Label',
                value: (
                  <Chip
                    label={sync.targetLabelName ?? ''}
                    size="small"
                    variant="outlined"
                    sx={(theme) => ({
                      color: theme.palette.primary.main,
                      borderColor: theme.palette.primary.main,
                      ml: -1,
                    })}
                  />
                ),
              },
              { label: 'Google Label Name', value: sync.targetLabelName },
              {
                label: 'Target Type',
                value: getTargetTypeLabel(sync.targetType),
              },
              {
                label: 'Targets',
                value: sync.allSource ? 'All' : sync.targets?.join(', '),
              },
            ].map((item) => (
              <Stack
                key={item.label}
                flexDirection="row"
                flexBasis={32}
                gap={1}
                sx={(theme) => ({
                  borderBottom: `1px solid ${theme.palette.divider}`,
                  px: 2,
                })}
              >
                <Typography flexBasis={200}>{item.label}</Typography>
                <Typography variant="body2" flexGrow="1">
                  {item.value}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
      }
      primaryButton={{
        loading: false,
        action: () => {
          handleClose();
        },
        title: 'Close',
        disabled: false,
      }}
    />
  );
}
